<div class="w-100 d-flex">
    <h6 class="mt-2 me-2">Total</h6>
    <button class="btn btn-primary btn-cart" (click)="openCart()" [disabled]="this.guidedService.cartLengths['total'] == 0">
        <!-- <fa-icon [icon]="faCart"></fa-icon> -->
        <img class="card-img" src="./assets/shopping-cart-full.svg" class="center" width="25" height="25" />
        <span *ngIf="this.guidedService.cartLengths['total'] != 0" class="ms-2 cart-number ps-2 pe-2">{{this.guidedService.cartLengths['total']}}</span>
    </button>
</div>